import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Layout from '../Layout/Layout';

const MedleyMakerPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const medleysUrl = window.location.origin.includes('localhost')
    ? `http://localhost:5173/v2/embedded/medleys`
    : '/v2/embedded/medleys';

  return (
    <Layout
      className="MedleyMakerRoute"
      title={t('main_nav.medleys')}
      contentStyle={{
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: 8,
      }}
    >
      <iframe src={medleysUrl} height="100%" width="100%" key={location.key} />
    </Layout>
  );
};

export default MedleyMakerPage;
